import { render, staticRenderFns } from "./DashboardProductStatusInactiveSku.vue?vue&type=template&id=709f824f&scoped=true&"
import script from "./DashboardProductStatusInactiveSku.vue?vue&type=script&lang=js&"
export * from "./DashboardProductStatusInactiveSku.vue?vue&type=script&lang=js&"
import style0 from "./DashboardProductStatusInactiveSku.vue?vue&type=style&index=0&id=709f824f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f824f",
  null
  
)

export default component.exports